export interface CouponCodeArgument {
  code: string
  multiplier: number
}

export default class CouponCode {
  readonly code: string
  readonly multiplier: number

  constructor(arg: CouponCodeArgument) {
    this.code = arg.code
    this.multiplier = arg.multiplier
  }

  static fromPG(data: any): CouponCode {
    return new CouponCode({
      code: data.code,
      multiplier: data.multiplier,
    })
  }
}
